import { render, staticRenderFns } from "./MultiTagEditor.vue?vue&type=template&id=48e1232a&scoped=true&"
import script from "./MultiTagEditor.vue?vue&type=script&lang=js&"
export * from "./MultiTagEditor.vue?vue&type=script&lang=js&"
import style0 from "./MultiTagEditor.vue?vue&type=style&index=0&id=48e1232a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e1232a",
  null
  
)

export default component.exports